import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'yup_favorites_v1';
const FavCtx = createContext(null);

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : { items: [] };
  } catch { return { items: [] }; }
}

export function FavoritesProvider({ children }) {
  const [state, setState] = useState(load);

  useEffect(() => { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }, [state]);

  const isFavorite = useCallback((id) => state.items.some(f => f.id === id), [state]);

  const toggle = useCallback((activity) => {
    setState(s => {
      const exists = s.items.find(f => f.id === activity.id);
      if (exists) return { items: s.items.filter(f => f.id !== activity.id) };
      const snap = {
        id: activity.id,
        name: activity.name,
        image: activity.image || activity.gallery?.[0],
        city_slug: activity.city_slug,
        category_key: activity.category_key,
        subcategory: activity.subcategory,
        rating: activity.rating,
        day: 1,
        added_at: Date.now(),
      };
      return { items: [...s.items, snap] };
    });
  }, []);

  const setDay = useCallback((id, day) => {
    setState(s => ({ items: s.items.map(f => f.id === id ? { ...f, day } : f) }));
  }, []);

  const remove = useCallback((id) => {
    setState(s => ({ items: s.items.filter(f => f.id !== id) }));
  }, []);

  const clear = useCallback(() => setState({ items: [] }), []);

  return (
    <FavCtx.Provider value={{ items: state.items, isFavorite, toggle, setDay, remove, clear, count: state.items.length }}>
      {children}
    </FavCtx.Provider>
  );
}

export function useFavorites() {
  const ctx = useContext(FavCtx);
  if (!ctx) throw new Error('useFavorites must be used inside FavoritesProvider');
  return ctx;
}
